import { US_PREVIEW, US_PREVIEW_VIEWBOX } from "@/lib/geo/us-preview";
import { riskVar, type RiskLevel } from "@/lib/risk";

/**
 * A thumbnail of the country with one state drawn in its level's colour and the rest in
 * the page's quiet ink, the way an atlas marks "you are here". Decorative: the state is
 * already named in the heading beside it.
 */
export function StateLocator({
  abbr,
  level,
  className,
}: {
  abbr: string;
  level: RiskLevel;
  className?: string;
}) {
  const others = US_PREVIEW.filter((g) => g.abbr !== abbr);
  const self = US_PREVIEW.find((g) => g.abbr === abbr);
  return (
    <svg viewBox={US_PREVIEW_VIEWBOX} aria-hidden className={className}>
      {others.map((g) => (
        <path
          key={g.abbr}
          d={g.d}
          fill="color-mix(in oklab, var(--foreground) 9%, transparent)"
          stroke="var(--card)"
          strokeWidth={1.2}
        />
      ))}
      {self && (
        <path
          d={self.d}
          fill={riskVar[level]}
          stroke="var(--foreground)"
          strokeWidth={2.5}
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}
